module.exports = __webpack_public_path__ + "static/media/046-micronesia.7f2fc2ed.svg";